import React from "react"
import { Link } from "gatsby"
import FoodCategories from "./FoodCategories"
import OptionsAndPrice from "./OptionsAndPrice"
import ControlPointIcon from "@material-ui/icons/ControlPoint"
import PhoneIcon from "@material-ui/icons/Phone"

const MenuCard = ({ details }) => {
  const {
    title,
    slug,
    allCitiessMetadata,
    allFoodTypessMetadata,
    restaurantACF,
  } = details

  const menuDate =
    restaurantACF.ongoinMenus[0].date &&
    restaurantACF.ongoinMenus[0].date !== null ? (
      <h3 className="h4 text-center mb-1">
        Menu du {restaurantACF.ongoinMenus[0].date}
      </h3>
    ) : (
      <h3 className="h4 text-center separator mb-1">
        Menu du {restaurantACF.ongoinMenus[0].dateDeDebut} au{" "}
        {restaurantACF.ongoinMenus[0].dateDeFin}
      </h3>
    )

  const platSeul =
    restaurantACF.optionPlatSeul && restaurantACF.tarifs.tarifPlatSeul ? (
      <h3 className="h5 text-center">
        Le plat seul à{" "}
        {new Intl.NumberFormat("fr-Fr", {
          style: "currency",
          currency: "EUR",
        }).format(restaurantACF.tarifs.tarifPlatSeul)}
      </h3>
    ) : null

  const starters = restaurantACF.ongoinMenus[0].starters ? (
    <div className="separator mb-1">
      <h2 className="h4 text-center mb-1">Entrées</h2>
      <div
        className="text-center"
        dangerouslySetInnerHTML={{
          __html: restaurantACF.ongoinMenus[0].starters,
        }}
      ></div>
    </div>
  ) : null

  const plats = restaurantACF.ongoinMenus[0].plats ? (
    <div className="separator mb-1">
      <h2 className="h4 text-center mb-1">Plats</h2>
      <div
        className="text-center"
        dangerouslySetInnerHTML={{ __html: restaurantACF.ongoinMenus[0].plats }}
      ></div>
    </div>
  ) : null

  const desserts = restaurantACF.ongoinMenus[0].desserts ? (
    <div className="separator mb-1">
      <h2 className="h4 text-center mb-1">Desserts</h2>
      <div
        className="text-center"
        dangerouslySetInnerHTML={{
          __html: restaurantACF.ongoinMenus[0].desserts,
        }}
      ></div>{" "}
    </div>
  ) : null

  return (
    <div className="cell small-12 large-6 mt-2" id={slug}>
      <article className="card--restaurant">
        <h1 className="text-center">{title}</h1>
        <FoodCategories cats={allFoodTypessMetadata} />
        <h2 className="h5 text-center mb-1">
          Adresse: {restaurantACF.address} à{" "}
          <strong>{allCitiessMetadata.nodes[0].name}</strong>
        </h2>
        <div className="flex-container mb-1">
          <Link className="button primary-dark mr" to={`/restaurants/${slug}`}>
            <ControlPointIcon />
            Voir le restaurant
          </Link>
          <a href={`tel:${restaurantACF.phone}`} className="button primary">
            <PhoneIcon />
            Appeler
          </a>
        </div>
        <div className="card--restaurant__menu bg-black">
          <OptionsAndPrice
            prices={restaurantACF.tarifs}
            menuType={restaurantACF.typeDeMenu}
          />
          {platSeul}
          <div className="bg-primary">
            <p className="text-center validity">
              Valable {restaurantACF.available}
            </p>
          </div>
          {menuDate}
          <div className="card--restaurant__menu__items">
            {starters}
            {plats}
            {desserts}
          </div>
        </div>
      </article>
    </div>
  )
}

export default MenuCard
